module.exports = __webpack_public_path__ + "static/img/IMG_20160307_133451.4327cdec.jpg";